export const isObject = (value) => {
  const typeOfValue = typeof value;

  return (
    value !== null && (typeOfValue === "object" || typeOfValue === "function")
  );
};
